import { Injectable } from '@angular/core';
import { NotificationService, ModalKeys, ModalIcon } from '../shared/notification/notification.service';
import { saveAs } from 'file-saver';
import sanitize from 'sanitize-filename';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EupHttpHandler } from '../core/eupHttpHandler.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams } from '@angular/common/http';
import { AssetsSdkService } from '../core/assets-sdk/assets-sdk.service';
import { SpinnerService } from '../core/spinner/spinner.service';
import { AssetReferenceType } from '@itero/assets-bff-sdk';

@Injectable()
export class DownloadFileService {
	constructor(
		private notificationService: NotificationService,
		private httpService: EupHttpHandler,
		private translateService: TranslateService,
		private assetsSdkService: AssetsSdkService,
		private spinnerService: SpinnerService
	) {}

	private fileName: string;

	getFile(url: string, options?: any, fileName?: string, triggerSpinner = true): Observable<ArrayBuffer> {
		this.fileName = sanitize(fileName);

		return this.httpService
			.get(url, { ...options, responseType: 'arraybuffer', withCredentials: true }, false, triggerSpinner)
			.pipe(
				map((response) => this.zipFileResponse(response)),
				catchError((err) => this.handleError(err))
			);
	}

	downloadExportGalleryFile(url: string, orderId: string, patientName: string, rxId?: string): void {
		if (this.assetsSdkService.isUseAssetsSdkSwoEnabled() && rxId) {
			this.spinnerService.start();
			this.assetsSdkService
				.downloadScreenshotsAsZip(
					rxId,
					orderId,
					AssetReferenceType.Fms_capture,
					'Errors.Error_download_screenshots_body',
					`${patientName.replace(/\s/g, '')}.zip`
				)
				.finally(() => this.spinnerService.stop());
			return;
		}

		const params = new HttpParams().set('orderId', orderId).set('assetReferenceType', AssetReferenceType.Fms_capture.toString());
		this.getFile(url, { params }, patientName.replace(/\s/g, '')).subscribe({
			error: () => {
				this.notificationService.show(
					this.translateService.instant('Errors.Error_download_file_title'),
					this.translateService.instant('Errors.Error_download_screenshots_body'),
					{ buttonCombination: ModalKeys.Ok, icon: ModalIcon.Error }
				);
			},
		});
	}

	private handleError(err) {
		this.notificationService.show(
			this.translateService.instant('Errors.Error_download_file_title'),
			this.translateService.instant('Errors.Error_download_file_body'),
			{ buttonCombination: ModalKeys.Ok, icon: ModalIcon.Error }
		);

		return throwError(err);
	}

	private zipFileResponse(response: ArrayBuffer): ArrayBuffer {
		this.saveAsZipFile(response, this.fileName);
		return response;
	}

	private saveAsZipFile(buffer: any, fileName: string): void {
		const data: Blob = new Blob([buffer], {
			type: 'application/x-zip-compressedapplication/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip',
		});
		saveAs(data, fileName + '.zip');
	}
	downloadSTLFile(url:string,fileName:string):Observable<any> {
		return this.httpService.get(url,{ responseType: 'blob',observe: 'response'})
		.pipe(
			map((response) => {
				saveAs(response.body!, fileName);
			}),
			catchError((err) => this.handleError(err))
		);
	}
}
